import { sentryBrowserConfig } from '~/sentry.browser.config';

sentryBrowserConfig();
